module.exports = "/_next/static/images/Frame-df8e92054de8de5452b2f05384675411.png";